import { captureBootstrapError, initSentry } from './app/telemetry/sentry';

// Initialize before evaluating application modules, including lazy bootstrap failures.
initSentry();
void import('./bootstrap').catch(captureBootstrapError);
